// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  FormLabelInput,
  TitleInputContainer,
  TitleDescription,
  MessageInputContainer,
  FormLabel,
  InputContainer,
  FormInput,
  FormNote,
} from "@/components/ui/form-elements";
import NodeContext from "../../context/NodeContext";
import { useContext } from "react";
import { Editor } from "react-draft-wysiwyg";
import { getHTMLToDraft } from "../../utils/helper";
import { toolbar } from "../../utils/constants";
import { LABELS } from "../../utils/labels";
import { Switch } from "@/components/ui/switch";
import { Tooltip } from "@mui/material";
import { FLOW_TYPE_SCREENING, FLOW_TYPE_RECONNECT, FLOW_TYPE_FAQ } from "../../constants";

function CalendarNodeEditor() {
  const { selectedNodeInfo, updateNode, variableList, setNewAddedNode, isEditable, profileType } =
    useContext(NodeContext);

  if (!selectedNodeInfo) {
    return null;
  }

  return (
    <>
      <TitleInputContainer>
        <FormLabelInput
          placeholder="Label"
          value={selectedNodeInfo?.data?.titleText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              titleText: e.target.value,
            });
          }}
        />
        <TitleDescription>
          Opens a calendar UI in the chat interface through which the user can
          select their desired date
        </TitleDescription>
      </TitleInputContainer>
      <MessageInputContainer>
        <div className="flex w-full items-center justify-between">
          <FormLabel className="mb-0">{LABELS.SHOW_MESSAGE}</FormLabel>
          {[FLOW_TYPE_SCREENING, FLOW_TYPE_RECONNECT, FLOW_TYPE_FAQ].includes(profileType) && (
            <Tooltip title="When enabled, the candidate can skip this question without providing an answer">
              <div className="flex items-center gap-2">
                <FormLabel className="mb-0 font-12px">{LABELS.SKIPPABLE}</FormLabel>
                <Switch
                  checked={selectedNodeInfo?.data?.isSkippable ?? false}
                  onCheckedChange={(checked) => {
                    updateNode(selectedNodeInfo.id, {
                      ...selectedNodeInfo?.data,
                      isSkippable: checked,
                      ...(!checked && { skipToNodeId: "" }),
                    });
                  }}
                  disabled={!isEditable}
                />
              </div>
            </Tooltip>
          )}
        </div>
        {/* <CKEditor
                    editor={ClassicEditor}
                    config={{
                        toolbar: [
                            "bold",
                            "italic",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "blockQuote",
                        ],
                        placeholder: "What is your...",
                    }}
                    onChange={(_, editor) => {
                        const data = editor.getData();
                        updateNode(selectedNodeInfo.id, {
                            ...selectedNodeInfo?.data,
                            message: data,
                        });
                    }}
                    data={selectedNodeInfo?.data?.message}
                /> */}
        <Editor
          editorState={getHTMLToDraft(selectedNodeInfo?.data?.message)}
          onEditorStateChange={(data) => {
            const isMessageEmpty = data.getCurrentContent().hasText();
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              message: data,
              isMessageEmpty: !isMessageEmpty,
            });
          }}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          toolbar={toolbar}
          mention={{
            separator: " ",
            trigger: "{",
            suggestions: variableList,
          }}
          onBlur={() => {
            setNewAddedNode(true);
          }}
          placeholder="What is your..."
          stripPastedStyles={true}
        />
      </MessageInputContainer>

      <MessageInputContainer></MessageInputContainer>

      <InputContainer>
        <FormLabel>{LABELS.SAVE_RESPONSE_VARIABLE}</FormLabel>
        <FormInput
          placeholder="Enter Variable Name"
          value={selectedNodeInfo?.data?.variableName}
          onBlur={() => {
            setNewAddedNode(true);
          }}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              variableName: e.target.value,
            });
          }}
        />
        <FormNote>
          You can add a variable that can be referenced later in the
          conversation.
        </FormNote>
      </InputContainer>
    </>
  );
}

export default CalendarNodeEditor;
